import React, { Fragment, useContext } from 'react';
import { bool, object, string } from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';

import { PdpSharedDealerDistinctions } from '../PdpSharedDealerDistinctions/PdpSharedDealerDistinctions';
import { PdpSharedDealerInfo } from '../PdpSharedDealerInfo/PdpSharedDealerInfo';
import { PdpSharedStarRating } from '../PdpSharedStarRating/PdpSharedStarRating';
import { PdpMobileStarRating } from '../PdpMobileStarRating/PdpMobileStarRating';
import { PdpSharedDealerDetailsHeader } from '../PdpSharedDealerDetailsHeader/PdpSharedDealerDetailsHeader';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import styles from './PdpSharedDealerDetailsStats.scss';

const PdpSharedDealerDetailsStatsComponent = props => {
    const { reviews, seller, user, showDescriptions, headerClass, viewer } = props;
    const { isMobile, isMobileWebPdpVariant } = useContext(ServerVarsContext);

    let feedbackRating = get(reviews, 'metadata.aggregatedFeedback.overallExperience.mean');
    feedbackRating = feedbackRating ? parseFloat(feedbackRating.toFixed(1)) : 0;

    return (
        <Fragment>
            <div className={styles.header}>
                <PdpSharedDealerDetailsHeader
                    headerClass={`${styles.heading} ${headerClass}`}
                    seller={seller}
                    user={user}
                    viewer={viewer}
                />
            </div>
            <div className={styles.ratingContainer}>
                {isMobile && isMobileWebPdpVariant ? (
                    <PdpMobileStarRating
                        feedbackRating={feedbackRating}
                        seller={seller}
                        reviews={reviews}
                    />
                ) : (
                    <PdpSharedStarRating feedbackRating={feedbackRating} />
                )}
            </div>
            <PdpSharedDealerDistinctions seller={seller} showDescriptions={showDescriptions} />
            <div className={styles.companyInfo}>
                <PdpSharedDealerInfo seller={seller} />
            </div>
        </Fragment>
    );
};

PdpSharedDealerDetailsStatsComponent.defaultProps = {
    showDescriptions: false,
};

PdpSharedDealerDetailsStatsComponent.propTypes = {
    seller: object.isRequired,
    user: object,
    reviews: object,
    showDescriptions: bool,
    headerClass: string,
    viewer: object,
};

export const PdpSharedDealerDetailsStats = createFragmentContainer(
    PdpSharedDealerDetailsStatsComponent,
    {
        viewer: graphql`
            fragment PdpSharedDealerDetailsStats_viewer on Viewer {
                ...PdpSharedDealerDetailsHeader_viewer
            }
        `,
        seller: graphql`
            fragment PdpSharedDealerDetailsStats_seller on Seller {
                ...PdpSharedDealerDistinctions_seller
                ...PdpSharedDealerInfo_seller
                ...PdpSharedDealerDetailsHeader_seller
                ...PdpMobileStarRating_seller
            }
        `,
        user: graphql`
            fragment PdpSharedDealerDetailsStats_user on User {
                ...PdpSharedDealerDetailsHeader_user
            }
        `,
        reviews: graphql`
            fragment PdpSharedDealerDetailsStats_reviews on SellerOrderFeedbackPdpQueryConnection {
                ...PdpMobileStarRating_reviews
                metadata {
                    aggregatedFeedback {
                        overallExperience {
                            mean
                        }
                    }
                }
            }
        `,
    }
);
